import React from "react";
import { Link } from "react-router-dom";
function Footer() {
  const footerStyle = {
    marginTop: "auto",
    backgroundColor: "transparent",
    color: "#4a9d6f",
    width: "100%",
    display: "block",
  };

  // Define link style based on theme
  const linkStyle = {
    color: "#4a9d6f",
    textDecoration: "none",
    transition: "color 0.3s ease",
  };
  return (
    <>
      <style>{`
        @media (max-width: 1150px) {
          .footer-content {
            flex-direction: column !important;
            text-align: center;
            padding-left: 0 !important;
          }
        }
      `}</style>
      <footer className="py-3 text-center" style={footerStyle}>
        <div
          className=" footer-content d-flex flex-column flex-md-row justify-content-between align-items-center flex-wrap"
          style={{ width: "100%" }}
        >
          {/* Left-aligned copyright */}
          <div className="text-center" style={{ paddingLeft: "1rem" }}>
            Copyright © 2026 Enlive Systems, Inc. All rights reserved.
          </div>

          {/* Centered links */}
          <div style={{ flex: "1" }}>
            <Link to="/privacypolicy" className="me-3" style={linkStyle}>
              Privacy Policy
            </Link>
            <Link to="/termsofuse" style={linkStyle}>
              Terms of Use
            </Link>
          </div>

          {/* Placeholder for right side to balance layout (optional) */}
          <div style={{ flex: "1" }} />
        </div>
      </footer>
    </>
  );
}

export default Footer;
